<template>
    <b-card
        :title="title"
        :loading="loading"
        :error-message="errorMessage"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
        :disabled="!hasPermission"
        @cancel="
            () => {
                colorEdit = false;
                $emit('back');
            }
        "
        @submit="
            () => {
                mode === 'update' ? hasPermission&&updateItem(item) : hasPermission&&createItem(item);
                colorEdit = false;
            }
        "
    >
        <b-text-field
            v-model="item.name[nameLang]"
            :label="translations.categoryName[lang]"
        >
            <template v-slot:append>
                <b-lang-menu v-model="nameLang" type="inner"></b-lang-menu>
            </template>
        </b-text-field>

        <v-row>
            <v-col cols="6" outlined>
                <div @click="colorEdit = !colorEdit">
                    <b-text-field
                        :label="translations.fontColor[lang]"
                        no-top-margin
                        v-model="item.text_color"
                        disabled
                    ></b-text-field>
                </div>
                <v-expand-transition>
                    <v-color-picker
                        canvas-height="80"
                        hide-sliders
                        v-model="item.text_color"
                        v-show="colorEdit"
                    ></v-color-picker>
                </v-expand-transition>
            </v-col>

            <v-col cols="6">
                <div @click="colorEdit = !colorEdit">
                    <b-text-field
                        :label="translations.backgroundColor[lang]"
                        no-top-margin
                        v-model="item.bg_color"
                        disabled
                    ></b-text-field>
                </div>
                <v-expand-transition>
                    <v-color-picker
                        canvas-height="80"
                        hide-sliders
                        v-model="item.bg_color"
                        v-show="colorEdit"
                    ></v-color-picker>
                </v-expand-transition>
            </v-col>
        </v-row>

        <v-file-input
            :label="translations.imageCategory[lang]"
            color="secondary"
            outlined
            dense
            hide-details
            v-model="item.upload"
        ></v-file-input>
        <div v-if="item.image" class="mt-4">
            {{ translations.lastUploaded[lang] }}
            <a :href="item.image">{{ item.image.substr(0, 40) }}...</a>
        </div>
    </b-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/catalogCategories";

export default {
    name: "CategoryForm",

    mixins: [translations],

    props: ["mode", "item", "dialog"],

    data() {
        return {
            lang: this.$route.params.lang,
            colorEdit: false,
            color: "#",
            nameLang: "en",
        };
    },
    computed: {
        ...mapState(["loading", "errorMessage"]),
        ...mapGetters({
            closeForm: "loyaltyPanel/giftCategories/getCloseForm",
        }),
        hasPermission () {
            return this.getPermission('gift_categories.' + this.mode)
        },
        title() {
            return this.mode === 'update'
                ? this.translations.editCategory[this.lang]
                : this.translations.addCategory[this.lang];
        },
    },
    watch: {
        closeForm() {
            this.$emit("back");
        },
        ["$route.params.lang"](val) {
            this.nameLang = val;
        },
    },
    methods: {
        ...mapActions(["getPermission"]),
        ...mapActions({
            createItem: "loyaltyPanel/giftCategories/create",
            updateItem: "loyaltyPanel/giftCategories/update",
        }),
    },
};
</script>
